import { validateProcedure } from './procedureValidator';
import { failedOutcome, resolveFood } from './outcome';
import type { FoodInput, FoodTestOutcome, ProcedureState } from './types';

export function getBiuretOutcome(food: FoodInput, procedure: ProcedureState): FoodTestOutcome {
  const validation = validateProcedure('protein', procedure);
  if (!validation.valid) return failedOutcome('protein', validation.errors.join(' '));
  const sample = resolveFood(food);
  const level = sample.composition.protein;
  const positive = level >= 0.15;
  return {
    test: 'protein',
    category: !positive ? 'negative' : level >= 0.65 ? 'strong-positive' : 'positive',
    observation: positive ? 'The blue mixture turns lilac to violet, indicating peptide bonds and protein.' : 'The mixture remains blue; protein is not detected.',
    colour: positive ? (level >= 0.65 ? '#7b3f98' : '#b77aca') : '#1677c8',
    colourName: positive ? (level >= 0.65 ? 'violet' : 'lilac') : 'blue',
    precipitate: false,
    emulsion: false,
    reasoning: 'In alkaline conditions, copper(II) ions form a violet complex with peptide bonds. Sodium hydroxide must be added before copper(II) sulfate.',
    warnings: validation.warnings,
  };
}